<script setup>

    import {computed, ref} from 'vue';
    import {ChevronDownIcon, ExclamationCircleIcon} from '@heroicons/vue/20/solid';

    const props = defineProps({
        menuItem: {
           type: Object,
           required: true
        },
        topics: Array || null,
        label: {
            type: String,
            default: 'Published Practice Parameters & Guidelines',
        },
        currentUrl: String,
        submenuClass: String || null,
    });

    function getMenuItemSlug(slug) {
        if(slug === 'home') {
            return '/';
        }
        return '/' + slug;
    }

    const isIndicator = ref(false);

    const menuName = computed(() => props.menuItem.menu_name ?? props.menuItem.name );

    const current = getMenuItemSlug(props.menuItem.slug) === '/' + props.currentUrl ? 'current text-primary-1' : '';

    const icon = ExclamationCircleIcon;

</script>

<template>
    <li
        :class="['relative text-right lg:text-center lg:font-bold text-2xl lg:text-lg text-blue-dark lg:py-2 lg:px-1',
    submenuClass]">
        <a :href="getMenuItemSlug(menuItem.slug)"
           :class="['flex relative w-full items-center justify-end lg:justify-start py-2 px-5 bg-white rounded-md hover:text-primary-1 transition-all duration-300',
        current]">
            <div v-if="isIndicator"
                class="w-6 text-red p-0 bg-gray-3 absolute top-0 left-full -mt-3 z-20 rounded-full overflow-hidden">
                <component :is="icon"/>
            </div>
            <span class="z-10" v-text="menuName"></span>
        </a>
    </li>
</template>

<style scoped>

</style>
